import React from 'react';
import PropTypes from 'prop-types';
import features from 'lib/common/features';

const bestAvailableUrl = features.getOption('bestAvailableLink', 'url');
const bestAvailableLabel = features.getOption('bestAvailableLink', 'labelText');

const BestAvailableLink = props => {
    return (bestAvailableUrl) ? (
        <a className="u-mini-link"
            href={`${bestAvailableUrl}${props.currentPerformanceId}`}>
            Choose Best Available Seats
        </a>
    ) : null;
};
BestAvailableLink.propTypes = {
    currentPerformanceId: PropTypes.number.isRequired,
    isAvailable: PropTypes.bool.isRequired // eslint-disable-line react/no-unused-prop-types
};

export default BestAvailableLink;



// WEBPACK FOOTER //
// ./src/javascripts/app/components/BestAvailableLink.js